import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef,  Inject, OnDestroy, OnInit, PLATFORM_ID, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { AcvisService } from '@app/services/acvis.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'clever-inclusive-list',
    templateUrl: './inclusive-list.component.html',
    styleUrls: ['./inclusive-list.component.scss'],
    standalone: false
})
export class InclusiveListComponent implements OnInit, OnDestroy {
    readonly mode = input<string>(undefined);
    readonly partner = input<Partner>(undefined);
    readonly inclusiveListExt = input<any[]>(undefined);
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    fromtraffics: boolean = false;
    slicenbr: number = 5;
    inclusiveList: any[] = [];
    selectedList: string[] = [];
    destroyRef = inject(DestroyRef);
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected acvisService: AcvisService,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
            const inclusiveListExt = this.inclusiveListExt();
            if (inclusiveListExt?.length > 0) {
                this.fromtraffics = true;
                const tmp = [];
                for (let i = 0; i < inclusiveListExt.length; i++) {
                    if (
                        inclusiveListExt[i].code !== 'MT' &&
                        inclusiveListExt[i].code !== 'OT' &&
                        inclusiveListExt[i].code !== 'MW' &&
                        inclusiveListExt[i].code !== 'CS' &&
                        inclusiveListExt[i].code !== 'FS' &&
                        inclusiveListExt[i].code !== 'CR' &&
                        inclusiveListExt[i].code !== 'ZG') {
                        tmp.push(inclusiveListExt[i]);
                    }
                }
                this.inclusiveList = this.sortArray(tmp);
            } else {
                this.initinclusiveList();
            }
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initinclusiveList(): void {
        this.acvisService.request({}, 'inclusiveList').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(res => {
            this.checktypes(res);
        });
    }

    checktypes(array) {
        for (let i = 0; i < array.length; i++) {
            if (this.partner()?.filters?.['hideinklusive' + array[i].code + 'filter']) {
                array.splice(i, 1);
                i--;
            }
        }

        this.inclusiveList = this.sortArray(array);
        this.cdr.detectChanges();
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    showMore(all) {
        this.slicenbr = all;
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.selectedList = [];
            if (filter.inclusiveList?.length > 0) {
                for (let i = 0; i < filter.inclusiveList.length; i++) {
                    this.selectedList.push(filter.inclusiveList[i].code);
                }
            }
            this.cdr.detectChanges();
        });
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op.code) >= 0) {
            push = false;
        }
        this.hotelService.inclusiveList(op, push, this.mode() !== 'home');
        this.cdr.detectChanges();
    }
}
